module.exports = __webpack_public_path__ + "img/update.ba938309.svg";